import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { ContactButton } from "../components/Project/Contact";
import { List as PointList } from "../components/Project/Choose";

const News = () => {
  const Message = () => {
    const gridProps = {
      main: {
        dir: ["column", "row"],
        size: ["100%"],
        layout: ["1fr 624px", "100%"],
        gap: ["80px", "64px"],
      },
    };
    return (
      <>
        <Space size={["184px auto 186px", "80px auto 72px"]}>
          <div className="l-row" data-state="left">
            <Grid {...gridProps.main}>
              <Media
                src="about/message-left"
                class="p-img__message"
                alt="media"
              ></Media>

              <div className="l-row--inner-left">
                <Title slug="company-message" type="single"></Title>
                <Space size={["56px 0 32px", "40px 0 24px"]}>
                  <Texts slug="about/message"></Texts>
                </Space>
                <Texts slug="about/profile"></Texts>
              </div>
            </Grid>
          </div>
        </Space>
      </>
    );
  };

  const AboutBox = () => {
    return (
      <>
        <div className="p-box__wrap">
          <Media
            src="box-back/about-page"
            alt="background"
            class="p-box__img--back"
          ></Media>
          <div className="p-box__wrap--white l-row">
            <div className="p-box__wrap--white__inner">
              <Title slug="about-box"></Title>
              <Space size={["80px 0", "64px 0"]}>
                <Texts slug="about/body-box"></Texts>
              </Space>
              <div className="p-title__wrap--section">
                <Texts class="c-text--med" slug={`about/title-box`}></Texts>
              </div>
              <Space size={["56px 0 40px", "48px 0 32px"]}>
                <Texts slug="about/body-box1"></Texts>
              </Space>
            </div>
          </div>
        </div>
      </>
    );
  };

  const TableElm = () => {
    return (
      <>
        <Space size={["120px 0 100px", "80px 0 72px"]}>
          <div className="l-row" data-state="min">
            <Title slug="information-company"></Title>
            <Space size={["100px auto 0", "64px auto 0"]}>
              <Table slug="company-list" len="14"></Table>
            </Space>
          </div>
        </Space>
      </>
    );
  };

  return (
    <>
      <Head slug="company"></Head>

      <Message></Message>

      <AboutBox></AboutBox>
    
      <TableElm></TableElm>

      <Banner></Banner>
      <Contact></Contact>
    </>
  );
};

export default News;
